import { DataSecurityLevel, KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { getReferral } from '@office-start/telemetry-utility';
import { generateEvent } from '../InstrumentationService';
// TODO: Add tests
export function logClickEvent(eventName, elementId, area, referral, referralPlatform, params, metrics, securityThreshold) {
    if (params === void 0) { params = {}; }
    if (metrics === void 0) { metrics = []; }
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    metrics = metrics || [];
    // Log metric that uniquely identifies click event only for known areas/elements
    if (area && elementId && elementId !== 'Unknown') {
        metrics.push("".concat(eventName, ".").concat(area, ".").concat(elementId));
    }
    if (elementId) {
        params["ElementId" /* InstrumentationParam.ElementId */] = elementId;
    }
    if (referral) {
        var safeReferral = getReferral(referral);
        params["Referral" /* InstrumentationParam.Referral */] = safeReferral;
        metrics.push("Referral.".concat(safeReferral));
        params["ReferralPlatform" /* InstrumentationParam.ReferralPlatform */] = referralPlatform
            ? {
                defaultValue: referralPlatform,
                securityThreshold: DataSecurityLevel.Enhanced,
                fallbackValue: 'Web',
            }
            : 'Web';
    }
    if (area) {
        params["Area" /* InstrumentationParam.Area */] = area;
    }
    // TODO: Figure out if this is needed for office-start
    // // Click events involved in page transitions are often given the wrong page value automatically. We're manually overriding them here if we detect a recent navigation.
    // // TODO: This is really a bandage solution on a larger systematic issue with how we log Page. There are other events, including impressions, requests, etc. that also
    // // end up receiving an incorrect value for reasons that aren't completely understood. These page nav clicks are singled out mainly because by their nature they have a
    // // very high error rate when it comes to assigning page. Ideally we would have a generic solution that fixes this for all events, but the implementation of such a fix
    // // is still unclear.
    // if (isPageNavEvent && this.lastPageNav && this.lastPageNav.from && (Performance.now() - this.lastPageNav.time < DispatcherInstrumentationService.lastPageNavTimeout)) {
    //     params[InstrumentationParam.Page] = this.lastPageNav.from;
    // }
    generateEvent(eventName, KnownInstrumentationEvents.GenericClick, securityThreshold, params, metrics, true);
}
//# sourceMappingURL=logClickEvent.js.map